import { create } from 'zustand';

const useScannerStore = create((set) => ({
  pairsCompleted: 0,
  lastPairedSerial: null,

  // Operator auth state
  operator: null,

  // Untracked boards toggle (allows scanning boards not yet in DB)
  allowUntrackedBoards: false,
  setAllowUntrackedBoards: (val) => set({ allowUntrackedBoards: val }),

  setOperator: (operator) => set({ operator }),
  clearOperator: () => set({ operator: null, pairsCompleted: 0, lastPairedSerial: null, allowUntrackedBoards: false }),

  recordPair: (serialnumber) =>
    set((state) => ({
      pairsCompleted: state.pairsCompleted + 1,
      lastPairedSerial: serialnumber,
    })),

  resetSession: () =>
    set({ pairsCompleted: 0, lastPairedSerial: null, operator: null, allowUntrackedBoards: false }),
}));

export default useScannerStore;
